import { defineStore } from "pinia";
import { useGeneralStore } from "@/stores/GeneralStore";

export const useUserStore = defineStore("UserStore", {
  state: () => ({
    token: null,
    user_id: null,
  }),
  getters: {},
  actions: {
    async userLogin(params) {
      const general = useGeneralStore();
      const config = useRuntimeConfig();

      const resIp = await $fetch("/api/others/get-client-ip", {
        method: "POST",
      });
      params.ipaddress = resIp.ip;

      let result;
      if (config.public.production) {
        const res = await $fetch("/api/user/login-sso", {
          method: "POST",
          body: params,
        });
        result = res;
      } else {
        const res = await $fetch("/api/user/check-login", {
          method: "POST",
          body: params,
        });
        result = res;
      }

      if (result.isSuccess == "not-ok") {
        general.showAlert({
          type: "error",
          title: "Login Failed",
          message: result.msg,
        });
        return false;
      }

      this.token = result.data[0].token;
      this.user_id = result.data[0].users.split(";")[2];

      general.resetInactivityTimer();

      general.showAlert({
        type: "success",
        title: "Login Success",
        message: "You have successfully logged in!",
      });

      return true;
    },

    async destroyTokenLogin() {
      const general = useGeneralStore();
      const config = useRuntimeConfig();

      const params = {
        token: this.token,
        source: "SPILCOID",
      };

      let result;
      if (config.public.production) {
        const res = await $fetch("/api/user/logout-sso", {
          method: "POST",
          body: params,
        });
        result = res;
      } else {
        const res = await $fetch("/api/user/destroy-sso-token", {
          method: "POST",
          body: params,
        });
        result = res;
      }

      if (result.isSuccess == "not-ok") {
        general.showAlert({
          type: "error",
          title: "Login Failed",
          message: result.msg,
        });
        return false;
      }

      general.showAlert({
        type: "success",
        title: "Logout Success",
        message: "You have successfully logged out.",
      });

      this.token = null;
      this.user_id = null;

      return true;
    },
  },
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
});
